<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            ref="grid"
            :summaryOptions="{
                enabled: true,
                columns: ['amount'],
            }"
            :expandedOptions="{
                enabled: true,
                allowExpandingAll: true,
                template: 'unprocessed-payment-details',
            }"
        ></dx-grid>
        <v-dialog v-model="depositChecksDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pt-1 pl-0"
                    >Deposit Checks</v-card-title
                >
                <v-card-text
                    v-if="selected.length"
                    class="py-0 px-0 font-weight-medium"
                    >The following checks will be marked as
                    processed</v-card-text
                >
                <v-card-text
                    v-if="!selected.length"
                    class="py-0 px-0 font-weight-medium text-danger"
                    >No 'check' payments selected. Please select check
                    payments</v-card-text
                >
                <v-list class="px-0 checks-to-process">
                    <template v-for="(check, index) in selected" class="px-0">
                        <v-list-tile class="px-0">
                            <v-list-tile-content class="px-0">
                                <v-list-tile-title>{{
                                    check.date | date
                                }}</v-list-tile-title>
                                <v-list-tile-sub-title></v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-spacer></v-spacer>
                            <v-list-tile-action
                                >#{{ check.checkNumber }}</v-list-tile-action
                            >
                            <v-spacer></v-spacer>
                            <v-list-tile-action
                                >${{ check.amount }}</v-list-tile-action
                            >
                        </v-list-tile>
                        <v-divider
                            v-if="index + 1 < selected.length"
                            :key="index"
                        ></v-divider>
                    </template>
                </v-list>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="depositChecksDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        :disabled="!selected.length"
                        @click="processChecks()"
                    >
                        Process
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { formatCurrency } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Unprocessed Payments",
        selected: [],
        depositChecksDialog: false,
        processing: false,

        actions: [],

        regID: "",
        url: "",
        source: "",

        columns: [
            {
                field: "statusValue",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value) => {
                    switch (value) {
                        case "PROCESSED":
                            return "mdi-check-circle";
                        case "DECLINED":
                            return "mdi-alert";
                        case "SCHEDULED":
                            return "mdi-clock";
                        case "SCHEDULED PAST DUE":
                            return "mdi-alert-octagon";
                        case "ERROR":
                            return "mdi-alert-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "PROCESSED":
                            return "success";
                        case "SCHEDULED":
                            return "#fdb400";
                        case "SCHEDULED PAST DUE":
                        case "DECLINED":
                        case "ERROR":
                            return "#f35123";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                link: (row) => {
                    if (row.categoryCode == "YKC") return "YKCAccountView";

                    return row.categoryCode == "LAPD"
                        ? "LapidusBillingView"
                        : "LapidusAccountView";
                },
                showLink: (row) => {
                    return true;
                },
            },
            {
                field: "paymentType",
                label: "PaymentType",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Transaction Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "processedDate",
                label: "Processed Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "dateCreated",
                label: "Date Created",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "amount",
                label: "Amount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "categoryDescription",
                label: "Category Description",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "status",
                label: "Status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: ["DECLINED", "ERROR", "SCHEDULED PAST DUE"],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "checkNumber",
                label: "Check Number",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "regID",
                label: "Reg ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "byUser",
                label: "User",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "actualBalance",
                label: "Actual Balance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: 0,
                selectedFilterOperation: ">",
            },
            {
                field: "description",
                label: "Description",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "paymentLogID",
                label: "Payment Log ID",
                format: "",
                type: "number",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "scheduleDetailID",
                label: "Schedule Detail ID",
                format: "",
                type: "number",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "receiptNumber",
                label: "Receipt Number",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "note",
                label: "Note",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountNote",
                label: "Account Note",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "followUpNote",
                label: "Follow Up Note",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "followUpDate",
                label: "Follow Up Date",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "fromSchedule",
                label: "From Schedule",
                format: "",
                visible: false,
                filterType: "",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "scheduleDisabled",
                label: "Schedule Disabled",
                format: "",
                visible: false,
                filterType: "",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "isImported",
                label: "Is Imported",
                format: "",
                visible: false,
                filterType: "",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "cardInfo",
                label: "Card Info",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "transactionResult",
                label: "Transaction Result",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "tranType",
                label: "Transaction Type",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "authorizationCode",
                label: "Authorization Code",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "sourceKey",
                label: "SourceKey",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "isVoided",
                label: "Is Voided",
                format: "",
                visible: false,
                filterType: "",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        this.$watch(
            () => this.$route.params,
            (toParams, previousParams) => {
                this.routeChanged(toParams, previousParams);
            },
        );
    },
    methods: {
        async beforeSetupGrid() {
            this.setSource();

            //await this.loadRegID();

            // const terms = await this.getTerms();

            // this.actions.push({
            //     text: "Select Term",
            //     type: "select",
            //     values: terms.map((t) => t.term),
            //     value: this.regID,
            //     onSelected: this.onTermSelected,
            // });

            this.actions.push({
                text: "Deposit Checks",
                action: this.depositChecks,
                showOnSelection: true,
            });

            this.url =
                "unprocessedPayments?source=" +
                (this.source ? this.source : "");
        },
        setSource() {
            this.source = this.$route.params.source;

            // if (this.isAdmin()) {
            //     return;
            // }

            // const roles = Array.isArray(this.$store.state.authentication.roles)
            //     ? this.$store.state.authentication.roles
            //     : this.$store.state.authentication.roles
            //     ? this.$store.state.authentication.roles.split(",")
            //     : [];

            // const isLapidusRole =
            //     roles.includes("Lapidus") || roles.includes("Lapidus Billing");

            // if (isLapidusRole) {
            //     this.source = "LAPIDUS";
            // }

            // const isYkRole = roles.includes("YK Camp");

            // if (isYkRole) {
            //     this.source = "YK";
            // }
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        routeChanged(newValue, oldValue) {
            console.log(newValue, oldValue);

            this.source = newValue.source;

            this.url =
                "unprocessedPayments?source=" +
                (this.source ? this.source : "");

            this.$refs.grid.reloadDataSource(this.url);
        },
        async loadRegID() {
            if (this.source == "YK") {
                this.regID = await this.$http.get("api/yk/getRegID");
            } else if (this.source == "LAPIDUS") {
                this.regID = await this.$http.get(
                    "api/lapidusDayCamp/getRegID",
                );
            }
        },
        async getTerms() {
            if (this.source == "YK")
                return await this.$http.get("api/yk/getRegTerms");

            return await this.$http.get("api/lapidusDayCamp/getRegTerms");
        },
        async onRowClicked(row) {
            if (row.categoryCode == "YKC") {
                this.$router.push({
                    name: "YKCAccountView",
                    params: { id: row.accountID, reg_id: row.regID },
                });

                return;
            }

            if (row.categoryCode == "LAPD") {
                this.$router.push({
                    name: "LapidusBillingView",
                    params: { id: row.accountID, reg_id: row.regID },
                });
                return;
            }

            this.$router.push({
                name: "LapidusAccountView",
                params: { id: row.accountID, reg_id: row.regID },
                query: {
                    isGirls: row.categoryCode == "LPDC",
                },
            });
        },
        onTermSelected(value) {
            this.regID = value;

            this.url = "unprocessedPayments?source=" + this.source;

            this.$refs.grid.reloadDataSource(this.url);
        },
        depositChecks(selected) {
            this.selected = selected.filter(
                (s) =>
                    s.paymentType.includes("Check") ||
                    s.paymentType == "Credit",
            );

            this.depositChecksDialog = true;
        },
        async processChecks() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/unprocessedPayments/ProcessChecks",
                    this.selected.map((s) => s.txnID),
                );

                this.processing = false;
                this.depositChecksDialog = false;

                this.$notify({
                    text: "Payments Processed",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.check-to-process .v-list__tile {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
</style>
